import type { Nullable } from '@ps/utils';

export const QUALIFICATION_TYPES = Object.freeze({
  SINGLE_PUNCH: 1,
  SINGLE_PUNCH_ALT: 2,
  MULTI_PUNCH: 3,
  RANGE: 4,
  INPUT: 5,
});

export const UNIT_QUALIFICATION_CODES = Object.freeze({
  INCOME: 213,
  AGE: 212,
  CHILD_AGE: 230,
});

export const CHILD_AGE_GENDER_QUALIFICATION_CODE = 232;

export const DECIPHER_UNITS = Object.freeze({
  INCOME: 321,
  AGE_YEAR: 311,
});

export function isRangeTypeQualification(type: number): boolean {
  return (
    type === QUALIFICATION_TYPES.RANGE || type === QUALIFICATION_TYPES.INPUT
  );
}

export function unitsForQualificationCode(
  qualificationCode: number,
): Nullable<number> {
  if (qualificationCode === UNIT_QUALIFICATION_CODES.INCOME) {
    return DECIPHER_UNITS.INCOME;
  }
  if (
    qualificationCode === UNIT_QUALIFICATION_CODES.AGE ||
    qualificationCode === UNIT_QUALIFICATION_CODES.CHILD_AGE
  ) {
    return DECIPHER_UNITS.AGE_YEAR;
  }
  return null;
}
